/**
 * Created by tomers on 3/30/2017.
 */
define(function (require) {
    "use strict";

    var LE = require("app");
    var ConversationSourcesLayout = require("manager-views/data-sources/conversation-sources/ConversationSourcesLayout");
    var ConversationSourcesGalleryView = require("manager-views/data-sources/conversation-sources/ConversationSourcesGalleryView");

    var ConversationSourcesGalleryController = {};

    function moduleDefinition(LEManager, LE, Backbone, Marionette, $, _) {
        ConversationSourcesGalleryController = Marionette.Controller.extend({
            conversationSourcesLayout: null,

            initialize: function(options) {
                this._initialize(options);
            },
            getView: function() {
                return this._getView();
            },

            _initialize: function(options) {
                this.channel = LEManager.media.channel("conversationSources");
                this._bindEvents();
            },

            _bindEvents: function() {
                this.listenTo(this.channel, "gallery:itemClick", this._onConversationSourceClick);
            },

            _getView: function() {
                this._initViews();
                return this.conversationSourcesLayout;
            },

            _initViews: function() {
                this.conversationSourcesLayout = new ConversationSourcesLayout();
                this.listenToOnce(this.conversationSourcesLayout, "render", this._onConversationSourcesLayoutRender);
            },

            _onConversationSourcesLayoutRender: function() {
                var conversationSourcesGalleryView = new ConversationSourcesGalleryView();

                this.conversationSourcesLayout.conversationSourcesGallery.show(conversationSourcesGalleryView);
            },

            _onConversationSourceClick: function(path) {
                LEManager.router.navigate(path);
            }
        });
    }

    LE.module("LEManager", moduleDefinition);

    return ConversationSourcesGalleryController;
});
